import Layout from 'comps/Layout';
import ShopIndexContentH5 from 'comps/ShopIndexContentH5';
import { SiteContext } from 'libs/contexts';
import { ShopIndexPageData } from 'pages/shop/index/[shopSysNo]';
import { useContext } from 'react';

export default function ShopIndex(props: ShopIndexPageData) {
  const site = useContext(SiteContext);

  return (
    <Layout
      header={null}
      footer={null}
      keywords="数字化,供应链管理,数字采购,供应链金融"
      description={`${
        site.basic?.tenantName || ''
      }通过数字化供应链管理、数字采购、供应链金融等产品和服务，实现产业链上下游协作，进而降本增效`}
    >
      <ShopIndexContentH5 {...props} />
    </Layout>
  );
}
